/**
 * Config welche Spalten in einer Tabelle angezeigt werden, mit welchem Namen
 */

import {
  MITARBEITER_ARCHIVE,
  MITARBEITER_ARCHIVE_DETAILS,
  MITARBEITER_DETAILS,
  MITARBEITER_UEBERSICHT,
} from "../utils/TableConstanten";

//Tabellen Einstellung
export var tableColums = {
  mitarbeiter: [
    //spalten für die Mitarbeiter Übersicht
    { dbName: "nachname", label: "Nachname" },
    { dbName: "vorname", label: "Vorname" },
    { dbName: "externe_mitarbeiter_id", label: "Externe ID" },
    { dbName: "geburtstag", label: "Geburtstag", format: "DD.MM.YYYY" },
    { dbName: "email", label: "E-Mail" },
    { dbName: "zuordnungs.bezeichnung", label: "Tätigkeit/Bereich" },
    { dbName: "zuordnungs.kommentar", label: "Kommentar" },
  ],
  firmenkartei: [
    { dbName: "bg_grundsatz", label: "BG Grundsatz" },
    { dbName: "anlass", label: "Anlass" },
    { dbName: "titel", label: "Titel" },
    { dbName: "vorsorgekartei.vorsorgeart", label: "Vorsorgeart" },
    { dbName: "vorsorgekartei.beschreibung", label: "Beschreibung" },
  ],
  zuordnung: [
    { dbName: "bezeichnung", label: "Tätigkeitsbereich" },
    { dbName: "typ", label: "Typ" },
    { dbName: "vorgesetzten_email", label: "Vorgesetzten E-Mail" },
    { dbName: "kommentar", label: "Kommentar" },
    { dbName: "firmen.name", label: "Firma" },
  ],
  vorsorgekartei: [
    { dbName: "bg_grundsatz", label: "BG Grundsatz" },
    { dbName: "anlass", label: "Anlass" },
    { dbName: "titel", label: "Titel" },
    { dbName: "vorsorgeart", label: "Vorsorgeart" },
    { dbName: "beschreibung", label: "Beschreibung" },
    { dbName: "ablaufsfrist", label: "Ablaufsfrist" },
  ],
  firmen: [
    { dbName: "name", label: "Name" },
    { dbName: "strasse", label: "Strasse" },
    { dbName: "plz", label: "PLZ" },
    { dbName: "ort", label: "Ort" },
  ],
  untersuchungen: [
    { dbName: "art", label: "Art" },
    { dbName: "gemacht_am", label: "durchgeführt", format: "MM/YYYY" },
    {
      dbName: "naechster_termin",
      label: "Nachuntersuchung",
      format: "MM/YYYY",
    },
    { dbName: "beurteilung", label: "Beurteilung" },
    { dbName: "kommentar", label: "Kommentar" },
    { dbName: "status", label: "Status" },
    { dbName: "mitarbeiter.nachname", label: "Nachname" },
    { dbName: "mitarbeiter.vorname", label: "Vorname" },
  ],
  benutzer: [
    { dbName: "username", label: "Benutzername" },
    { dbName: "email", label: "E-Mail" },
    { dbName: "rolle", label: "Rolle" },
    { dbName: "firmen.name", label: "Firma" },
  ],
  emailLog: [
    { dbName: "to", label: "Empfänger" },
    { dbName: "subject", label: "Betreff" },
    {
      dbName: "status",
      label: "Status",
      filterType: "chips",
      options: [
        { value: "queued", label: "Geplant", className: "chip-warning" },
        { value: "sent", label: "Gesendet", className: "chip-success" },
        { value: "failed", label: "Fehler", className: "chip-danger" },
      ],
      render: (value) => (
        <span
          className={`badge badge-${value === "sent" ? "success" : value === "failed" ? "danger" : "warning"}`}
        >
          {value === "sent"
            ? "Gesendet"
            : value === "failed"
              ? "Fehler"
              : "Geplant"}
        </span>
      ),
    },
    {
      dbName: "sendDateActual",
      label: "Gesendet am",
      format: "DD.MM.YYYY HH:mm",
    },
    {
      dbName: "trigger",
      label: "Auslöser",
      filterType: "chips",
      options: [
        { value: "comingUpExamination", label: "Anstehende Untersuchung" },
        { value: "angebotExamination", label: "Angebotsuntersuchung" },
        { value: "bereichExamination", label: "Bereichsuntersuchung" },
        { value: "testMail", label: "Test-Mail" },
      ],
      render: (value) => {
        const labels = {
          comingUpExamination: "Anstehende Untersuchung",
          angebotExamination: "Angebotsuntersuchung",
          bereichExamination: "Bereichsuntersuchung",
          testMail: "Test-Mail",
        };
        return labels[value] || value || "-";
      },
    },
    // Nur für Superadmin; Sortierung nach Relations-Spalten wirft im
    // emailLog-Backend einen SQL-Fehler (dotted orderBy wird als Identifier
    // gequoted), daher sortable:false. Filter-Ausschluss: siehe TableBox.
    {
      dbName: "firmen.name",
      label: "Firma",
      superAdminOnly: true,
      sortable: false,
    },
    // Superadmin-Firmenfilter: filter-only-Eintrag (keine Spalte, siehe
    // col.filter-Semantik in Table.js); Optionen kommen dynamisch über die
    // filterOptions-Prop der EmailVerlauf-Seite.
    {
      dbName: "firmenId",
      label: "Firma",
      superAdminOnly: true,
      filter: true,
      filterType: "select",
      options: [],
    },
  ],
  [MITARBEITER_UEBERSICHT]: [
    { dbName: "bg_grundsatz", label: "BG Grundsatz", filter: true },
    { dbName: "nachname", label: "Nachname" },
    { dbName: "vorname", label: "Vorname" },
    { dbName: "bezeichnung", label: "Tätigkeiten/Bereiche" },
    {
      dbName: "statistik",
      label: "Statistik",
      group: ["red", "yellow", "green"],
    },
  ],
  [MITARBEITER_DETAILS]: [
    { dbName: "bg_grundsatz", label: "BG Grundsatz" },
    { dbName: "beurteilung", label: "Beurteilung" },
    { dbName: "gemacht_am", label: "Durchgeführt", format: "MM-YYYY" },
    {
      dbName: "naechster_termin",
      label: "Nachuntersuchung",
      format: "MM-YYYY",
    },
    { dbName: "dateiAnzahl", label: "Dateien", icon: "FaRegFileAlt" },
  ],
  [MITARBEITER_ARCHIVE]: [
    { dbName: "nachname", label: "Nachname" },
    { dbName: "vorname", label: "Vorname" },
    { dbName: "geburtstag", label: "Geburtstag", format: "DD.MM.YYYY" },
    { dbName: "email", label: "E-Mail" },
    { dbName: "bezeichnung", label: "Bezeichnung" },
    { dbName: "kommentar", label: "Kommentar" },
  ],
  [MITARBEITER_ARCHIVE_DETAILS]: [
    { dbName: "bg_grundsatz", label: "BG Grundsatz" },
    { dbName: "titel", label: "Titel" },
  ],
};

//Formular/Modal renames
export var modalTitleRename = {
  vorsorgekartei: "Untersuchung",
};

//Rename der Form Labels
export var formInputRename = {
  bg_grundsatz: "BG Grundsatz",
};

//Tabellen Standart Sortier angaben
export var tableDefaultSort = {
  mitarbeiter: {
    sortOrder: "ASC",
    orderBy: "nachname",
  },
  emailLog: {
    sortOrder: "DESC",
    orderBy: "sendDateActual",
  },
};
